// import axios from 'axios';
// import { observer } from 'mobx-react-lite';
// import React, { useCallback, useEffect, useState } from 'react';
// import useDimensions from 'react-use-dimensions';
// import { FormattedMessage, useIntl } from 'react-intl';

// import { getRegionFromLocale } from '../../util/localeUtil';

// import { useStore } from '../../components/StoreProvider';
// import Layout from '../../components/Layout';
// import MessageModal from '../../components/MessageModal';
// import SEO from '../../components/SEO';
// import VideoModal from '../../components/VideoModal';

// import Hero from '../../pageComponents/home/Hero';
// import Trailer from '../../pageComponents/home/Trailer';
// import BeepBoop from '../../pageComponents/home/BeepBoop';
// import Projection from '../../pageComponents/home/Projection';
// import AutonomousMovement from '../../pageComponents/home/AutonomousMovement';
// import LightSaber from '../../pageComponents/home/LightSaber';
// import Arms from '../../pageComponents/home/Arms';
// import AppControlV2 from '../../pageComponents/home/AppControlV2';
// import Camera from '../../pageComponents/home/Camera';
// import OwnR2V3 from '../../pageComponents/home/OwnR2V3';
// import BuildYourselfSubscription from '../../pageComponents/home/BuildYourselfSubscription';
// import BuildService from '../../pageComponents/home/BuildService';
// import Guide from '../../pageComponents/home/Guide';
// import EveryPack from '../../pageComponents/home/EveryPack';
// import BuildYourselfKit from '../../pageComponents/home/BuildYourselfKit';

// const BASE_URLS = process.env.ALL_BASE_URLS;

// const IndexPage = ({ uri }) => {
//   const intl = useIntl();
//   const { cartStore } = useStore();

//   const [dark, setDark] = useState(false);
//   const [darkSectionRef, darkSection] = useDimensions();

//   const [hideBuy, setHideBuy] = useState(true);
//   const [buySectionRef, buySection] = useDimensions();

//   const [activeVideo, setActiveVideo] = useState();
//   const closeVideoModal = useCallback(() => {
//     setActiveVideo(null);
//   }, []);

//   // Temporarily redirect all Taiwanese users to the TW site
//   const region = getRegionFromLocale(intl.locale);
//   useEffect(() => {
//     const redirectTwIfNeeded = async () => {
//       try {
//         const { data } = await axios(
//           'https://www.cloudflare.com/cdn-cgi/trace'
//         );
//         const result = /loc=([A-Z][A-Z])/.exec(data);
//         const clientRegion = result?.[1]?.toLowerCase();
//         if (clientRegion === 'tw' && region !== 'tw') {
//           window.location = BASE_URLS.tw;
//         }
//       } catch (err) {
//         // Do nothing if it fails
//       }
//     };
//     redirectTwIfNeeded();
//   }, [region]);

//   useEffect(() => {
//     const setCssVh = () => {
//       const vh = window.innerHeight * 0.01;
//       document.documentElement.style.setProperty('--vh', `${vh}px`);
//     };
//     setCssVh();
//     window.addEventListener('resize', setCssVh);
//     return () => {
//       window.removeEventListener('resize', setCssVh);
//     };
//   }, []);

//   useEffect(() => {
//     function onScroll() {
//       const atDarkSection =
//         darkSection.y + darkSection.height > 100 &&
//         darkSection.y + darkSection.height < darkSection.height + 100;
//       if (atDarkSection !== dark) {
//         setDark(atDarkSection);
//       }

//       const atBuySection =
//         buySection.y + buySection.height > 100 &&
//         buySection.y + buySection.height < buySection.height + 100;
//       if (atBuySection !== hideBuy) {
//         setHideBuy(atBuySection);
//       }
//     }
//     onScroll();
//     window.addEventListener('scroll', onScroll);
//     return () => {
//       window.removeEventListener('scroll', onScroll);
//     };
//   }, [darkSection.y, darkSection.height, buySection.y, buySection.height]);

//   return (
//     <Layout
//       dark={dark}
//       showBuyButton={!hideBuy}
//       showMobileLogo={false}
//       uri={uri}
//     >
//       <SEO
//         title={intl.formatMessage({
//           id: 'meta.title.home',
//           defaultMessage: 'Build Your Own R2-D2'
//         })}
//         description={intl.formatMessage({
//           id: 'meta.description.home',
//           defaultMessage:
//             'Build Your Own R2-D2 - Official replica of the most famous astromech droid in the galaxy from STK Workshop. Subscribe to the series and have each pack delivered to you monthly or bi-monthly, or have your model assembled by our master builders, including optional weathering. Check out our online offers now.'
//         })}
//       />
//       <VideoModal
//         open={!!activeVideo}
//         video={activeVideo}
//         onClose={closeVideoModal}
//       />
//       <Hero />
//       <div ref={darkSectionRef}>
//         <div id="trailer">
//           <Trailer onOpenVideo={setActiveVideo} showPlayButton />
//         </div>
//         <BeepBoop />
//         <Projection />
//       </div>
//       <div style={{ backgroundColor: '#000' }}>
//         <LightSaber />
//         <Arms />
//       </div>
//       <AutonomousMovement />
//       <AppControlV2 />
//       <Camera />
//       <div ref={buySectionRef}>
//         <div id="buy">
//           <OwnR2V3 />
//         </div>
//         <div id="build-yourself-subscription">
//           <BuildYourselfSubscription />
//         </div>
//         {process.env.REGION === 'hk' && (
//           <div id="build-yourself-kit">
//             <BuildYourselfKit />
//           </div>
//         )}
//         <div id="build-service">
//           <BuildService />
//         </div>
//       </div>
//       <Guide />
//       <EveryPack />

//       <MessageModal
//         open={cartStore.isCartErrorModalOpen}
//         onClose={cartStore.closeCartErrorModal}
//         title={
//           <FormattedMessage defaultMessage="Could not add product to cart" />
//         }
//       >
//         <p>
//           <FormattedMessage defaultMessage="Subscription orders must be placed separately from single item orders." />
//         </p>
//         <p>
//           <FormattedMessage defaultMessage="Please confirm your single item order first and then place a separate order for your subscription purchase." />
//         </p>
//         <p style={{ fontSize: '0.72em' }}>
//           <FormattedMessage defaultMessage="We apologize for the inconvenience - this is a requirement of the third party secure payment provider to ensure charges are processed correctly. If you're having any problems placing your multiple item order, please contact us and we'll help." />
//         </p>
//       </MessageModal>
//     </Layout>
//   );
// };

// export default observer(IndexPage);

import React from 'react';
import Redirect from '../../components/Redirect';

const IndexPage = () => {
  return <Redirect to="https://www.stk-workshop.com/" includeQuery />;
  // return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
